import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';

import { PATH_TO_BANNER_MAP } from './constants';

export const useBannerKey = () => {
    const location = useLocation();

    const bannerKey = useMemo(() => {
        const key = Object.keys(PATH_TO_BANNER_MAP).find((item) => location.pathname.startsWith(item));

        return key ? PATH_TO_BANNER_MAP[key as keyof typeof PATH_TO_BANNER_MAP] : undefined;
    }, [location.pathname]);

    return bannerKey;
};
